// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 10108-会员行为记录详情 GET /web/v1/member/action/detail/${param0} */
export async function getMemberActionDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getMemberActionDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimmerActionRespVO>(
    `/web/v1/member/action/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10107-会员行为记录列表 GET /web/v1/member/action/list */
export async function getMemberActionList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getMemberActionListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOPageSwimmerActionRespVO>(
    "/web/v1/member/action/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 10106-会员行为上报(内部) POST /web/v1/member/action/report */
export async function reportMemberAction(
  body: API.SwimmerActionReportReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/member/action/report", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10102-创建会员 POST /web/v1/member/create */
export async function createMember(
  body: API.MemberCreateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/web/v1/member/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10103-Web端会员信息查询 GET /web/v1/member/detail */
export async function getMemberDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getMemberDetailParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOMemberInfoRespVO>("/web/v1/member/detail", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 10105-会员人脸信息上传 POST /web/v1/member/faceImgUpload */
export async function uploadMemberFaceImg(
  body: API.MemberFaceImgUploadReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/member/faceImgUpload", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10101-查询场馆会员列表 POST /web/v1/member/member/list */
export async function getMemberList(
  body: API.SwimMemberListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimMemberListVo>(
    "/web/v1/member/member/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10104-会员信息修改 POST /web/v1/member/update */
export async function updateMember(
  body: API.MemberUpdateReqVO,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/member/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
